import { Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const IdFiltersWrapper = styled(Flex)`
  flex-flow: column nowrap;
  padding: 8px;
  font-weight: normal;
`
